import { CustomRow, GenericEnum } from 'interfaces/utils';
import { toCurrency } from 'utils/currency';

export const serviceCategoryTotalRows: CustomRow[] = [
  {
    field: 'totalCustomer',
    label: 'Clientes',
    options: { align: 'right' },
  },
  { field: 'totalContract', label: 'Contratos' },
  {
    field: 'totalCurrentTotalValue',
    label: 'Valor Total',
    getParsedValue: (value) => toCurrency(Number(value)),
  },
];

export const simulationRows: CustomRow[] = [
  { field: 'name', label: 'Régua' },
  { field: 'totalCustomer', label: 'Clientes' },
  { field: 'totalContract', label: 'Contratos' },
  {
    field: 'totalCurrentTotalValue',
    label: 'Valor Total',
    getParsedValue: (value) => toCurrency(Number(value)),
  },
];

export const serviceCategoriesEnum: GenericEnum = {
  massiveAction: 'Ação Massiva',
  activeAction: 'Ação Ativa/ESCOB',
  oiPortal: 'Portal Oi',
  bureauPortal: 'Portal Bureau',
  negotiationService: 'Atendimento de Negociação (0800)',
};
